class McAccountForm extends HTMLElement {
    constructor() {
        super();
    }

    get forms() {
        return this.querySelectorAll('form[mc-account-form]');
    }

    connectedCallback() {
        this.forms.forEach(form => {
            form.addEventListener('submit', (event) => {
                if (!this.validateForm(form)) {
                    event.preventDefault();
                }
            });
        });
    }

    resetFormErrors(form) {
        form.querySelectorAll('small[error]').forEach(errorElement => {
            errorElement.setAttribute('data-active', 'false');
        });
    }

    isEmpty(inputElement) {

        if (inputElement.type === 'checkbox' && !inputElement.checked) {
            this.setInputError(inputElement);
            return true;
        }
        if (!inputElement.value?.trim()) {
            this.setInputError(inputElement);
            return true;
        }
        return false;
    }

    setInputError(inputElement) {
        const inputError = this.getInputErrorElement(inputElement);
        if (inputError) {
            inputError.setAttribute('data-active', 'true');
        }
    }

    getInputErrorElement(inputElement) {
        return inputElement.closest('div')?.querySelector('small[error]') || null;
    }

    validateForm(form) {
        let isValid = true;
        this.resetFormErrors(form);
        const requiredInputs = form.querySelectorAll('input[required]');

        requiredInputs.forEach(input => {
            if (this.isEmpty(input)) {
                isValid = false;
            }
        });

        return isValid;
    }
}

customElements.define("account-form", McAccountForm);
